mutation RestoreCollectionTypes($ids: [ID!]!) {
  restoreCollectionTypes(ids: $ids) {
    id
  }
}
